module.exports = __webpack_public_path__ + "assets/img/me-icon-active.e44a426a.png";